import React from 'react';
import { Typography } from 'antd';
import theme from '../../theme';

// const TYPOGRAPHY_TEXT = 'text';
export const TYPOGRAPHY_TITLE = 'title';
export const TYPOGRAPHY_PARAGRAPH = 'paragraph';

const { Text, Title, Paragraph } = Typography;

const CustomTypography = props => {
  const { textType, fontSize, themeColor, lineHeight, style, ...otherProps } = props;
  const customStyle = {
    fontSize: fontSize ? fontSize : undefined,
    color: themeColor ? themeColor : undefined,
    lineHeight: lineHeight ? `${lineHeight}px` : undefined,
    ...style,
  };
  return (
    <>
      <Choose>
        <When condition={textType === TYPOGRAPHY_TITLE}>
          <Title {...otherProps} style={customStyle} />
        </When>
        <When condition={textType === TYPOGRAPHY_PARAGRAPH}>
          <Paragraph {...otherProps} style={customStyle} />
        </When>
        <Otherwise>
          <Text {...otherProps} style={customStyle} />
        </Otherwise>
      </Choose>
    </>
  );
};

export default CustomTypography;
